import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
  FDImage,
  FDPrimaryActionButton,
  useFDBodyColor,
  FDAvatar,
  FDSecondaryActionButton, FDBodyText,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { dataAttrs } from 'Helpers/Testing';
import {
  useBuildCommonFQEventProperties,
} from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';
import { QuizWrapperLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/QuizWrapperLayout';
import fr from 'facet-rest';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import { useSnackbarContext } from 'Context/SnackbarContext';

const InsightAction = () => {
  const { resource, onSubmit } = useMetaLayoutContext();
  const {
    fetchCollectionByLink,
  } = useCollectionStateContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  useScrollTopOnMount();

  useFDBodyColor('calm');

  return (
    <QuizWrapperLayout>
      <FDStack direction={'column'} spacing={4} {...dataAttrs('insight-container')}>
        <FDStack direction={'column'} spacing={2}>
          <FDStack direction={'column'} spacing={2}>
            {resource.withRelationship(fr.relationships.avatar.name,
              (rel) => (
                <FDStack direction={'column'} alignItems={'center'} paddingY={2}>
                  <FDAvatar
                    src={rel.link('related').url()}
                    alt={rel.meta('altText') || ''}
                    size={'xl'}
                  />
                </FDStack>),
              () => null)}
            <MetaControlField attr={'title'} />
            <MetaControlField attr={'insightDescription'} />
            {resource.withRelationship(fr.relationships.image.name,
              (rel) => (
                <FDStack direction={'column'} paddingY={4}>
                  <FDImage
                    src={rel.link('related').url()}
                    alt={rel.meta('altText') || ''}
                    aspectRatio={rel.meta('aspectRatio')}
                  />
                </FDStack>),
              () => null)}
          </FDStack>
          {resource.meta().canPut()
            && <FDPrimaryActionButton
              onClick={() => {
                logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
                  eventProperties: {
                    ...buildCommonFQEventProperties(resource),
                    insightId: resource.attr('insightId'),
                    insightReferenceName: resource.attr('insightReferenceName'),
                    isPrimaryAction: true,
                  },
                });
                onSubmit();
              }}
              isFullWidth
              {...dataAttrs('primary-action-button')}
              label={'Continue'}
            />
          }
          {resource.withRelationship('secondaryAction',
            (rel) => (
              <FDStack direction={'column'} alignItems={'center'} width={'100%'} spacing={2}>
                <FDBodyText value="or" />
                <FDSecondaryActionButton
                  onClick={async () => {
                    logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
                      eventProperties: {
                        ...buildCommonFQEventProperties(resource),
                        insightId: resource.attr('insightId'),
                        insightReferenceName: resource.attr('insightReferenceName'),
                        isPrimaryAction: false,
                      },
                    });
                    try {
                      await fetchCollectionByLink(rel.link('related').url());
                    } catch (e) {
                      displayErrorMessage(e, e.errors || 'Error navigating to booking screen.');
                    }
                  }}
                  isFullWidth
                  {...dataAttrs('secondary-action-button')}
                  label={'Schedule your free intro call'}
                />
              </FDStack>
            ),
            () => null)}
        </FDStack>
      </FDStack>
    </QuizWrapperLayout>
  );
};


export { InsightAction };
